import { Link, useNavigate, useParams } from "react-router-dom";
import patient from "../../../assets/img/patient.jpg";
import React, { useEffect, useRef, useState } from "react";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ToastContainer } from "react-toastify";
import Textarea from "../../../components/text-area";
import { prompts } from "../../../util/dummyJson";
import {
  ADMIN_CMS_IMAGE_UPLOAD_AWS,
  ADMINPROMPTS,
  ADMINTEMPLATE,
  DIAGONASTIC_TOOL,
  PRACTICE_FRAMEWORK,
} from "../../../action/apiPath";
import { CallWithAuth } from "../../../action/apiActions";
import AdminPromptsPageAddOrEdit from "./components/addEdit";
import AdminTemplatesPageAddOrEdit from "./components/addEdit";
import { Spinner } from "react-bootstrap";
import { PiFilePdf } from "react-icons/pi";
import { showToast } from "../../../util/toastHelper";

const MySwal = withReactContent(Swal);

/**
 * The Patient Relatives Information Page component
 * @returns {JSX.Element} The component
 */
const AdminTemplatesPageAdd = () => {
  const { id } = useParams();
  const [isEditvalue, setIsEditValue] = React.useState(false);
  const [refetch, setRefetch] = useState(0);

  React.useEffect(() => {
    if (id) setIsEditValue(true);
  }, [id]);

  const [sampleReports, setSampleReports] = useState([]);
  const ref = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    if (files.length === 0) return;
    handleFileChange({ target: { files } });
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files.length == 0) {
      return;
    }

    for (let file of files) {
      if (file.type != "application/pdf") {
        showToast("Only pdf is allowed");
        ref.current.value = '';
        return;
      }
    }

    if (sampleReports.length < 5) {
      const min = 5 - sampleReports.length;
      if (files.length < min) {
        showToast("error", `Minimun ${min} files needed`);
        ref.current.value = '';
        return
      }
    }

    setSelectedFiles(Array.from(files).map(f => f.name));
    apiCallFileUpload(files);
  };

  const apiCallFileUpload = async (files) => {
    setUploading(true);

    let _uploadedFilesUrl = [];
    for (let file of files) {
      const formdata = new FormData();
      formdata.append("file", file);

      try {
        const response = await CallWithAuth("POST", ADMIN_CMS_IMAGE_UPLOAD_AWS, formdata);
        if (response?.res?.status === 200 || response?.res?.status === 201) {
          _uploadedFilesUrl.push(response?.res?.data?.file_url)
        } else {
          showToast("error", "Unable to upload");
        }
      } catch (err) {
        showToast("error", err);
      }
    }

    if (_uploadedFilesUrl.length == 0) {
      showToast("error", "Unable to upload files");
      setUploading(false);
    } else {
      saveSampleReports(_uploadedFilesUrl);
    }
  }

  const saveSampleReports = async (fileUrls) => {
    try {
      const response = await CallWithAuth(
        "POST",
        `${ADMINTEMPLATE}/example_reports`,
        {
          template_id: id,
          example_reports: fileUrls
        }
      )

      if (response?.res?.status === 200 || response?.res?.status === 201) {
        showToast("Files uploaded successfully")
        setRefetch(1);
      } else {
        showToast("error", "Something went wrong!");
      }
    } catch (err) {
      showToast("error", err);
    }

    ref.current.value = '';
    setUploading(false);
  };

  const handleDeleteSampleReport = async (_report) => {
    const r = window.confirm("Are you sure you want to delete this report?");
    if (r === true) {
      try {
        setRefetch(2);
        const response = await CallWithAuth(
          "DELETE",
          `${ADMINTEMPLATE}/example_reports/${_report.id}`,
        )

        if (response?.res?.status === 200 || response?.res?.status === 201) {
          showToast("Example report deleted successfully")
          setRefetch(1);
        } else {
          showToast("error", "Something went wrong!");
          setRefetch(0);
        }
      } catch (err) {
        showToast("error", err);
        setRefetch(0);
      }
    }
  }

  console.log(sampleReports);

  return (
    <>
      <div className="front-end-dashboard">
        <div className="site_container">
          {/* start: dashboard-page-header */}
          <div className="dashboard-page-header">
            <div className="left-div">
              <h3>{id ? "Update Templates" : "Add Templates"}</h3>
            </div>
          </div>
          <div className="dashboard-page-body">
            <AdminTemplatesPageAddOrEdit 
              isEdit={isEditvalue} 
              setSampleReports={(_reports) => {
                setSelectedFiles([]);
                setSampleReports(_reports);
                setRefetch(0);
              }} 
              refetch={refetch}
            />
          </div>
          
          {isEditvalue ? <>
            <div className="dashboard-page-header">
              <div className="left-div">
                <h3>Sample Reports</h3>
              </div>
            </div>
            <div className="dashboard-page-body">
              <div
                className="option-boxContent-card p-3 border rounded"
                onClick={() => document.getElementById("assessmentFileInput").click()}
                style={{ cursor: "pointer" }}
                onDragOver={(e) => {
                  e.preventDefault();
                  e.currentTarget.classList.add("drag-over");
                }}
                onDrop={(e) => {
                  e.preventDefault();
                  e.currentTarget.classList.remove("drag-over");
                  handleDrop(e)
                }}
              >
                <figure className="text-center">
                  <div className="icon">
                    <PiFilePdf size={28} />
                  </div>
                  <figcaption>Example Reports</figcaption>
                </figure>
                <h6>Supported: PDF / DOC / DOCX</h6>
                <p>Drag & Drop or Browse to upload</p>

                {/* Uploading Loader */}
                {uploading ? (
                  <div className="text-center mt-2">
                    <Spinner animation="border" size="sm" /> Uploading...
                  </div>
                ) : (
                  selectedFiles.length > 0 && (
                    <ul className="mt-2">
                      {selectedFiles.map((name, idx) => (
                        <li key={idx}>{name}</li>
                      ))}
                    </ul>
                  )
                )}

                <input
                  id="assessmentFileInput"
                  type="file"
                  accept=".pdf"
                  multiple
                  style={{ display: "none" }}
                  onChange={(e) => handleFileChange(e)}
                  ref={ref}
                />
              </div>

              <div className="file-list-container row g-3 mt-1">
                {sampleReports.map((item) => {
                  return (
                    <div key={item.id} className="col-sm-6">
                      <div className="file-item p-3 border rounded d-flex align-items-center bg-white shadow-sm h-100 position-relative">

                        {/* Action Icons Container */}
                        <div className="position-absolute d-flex align-items-center gap-2" style={{ top: '8px', right: '10px' }}>
                          {/* DELETE ICON */}
                          <button
                            onClick={() => handleDeleteSampleReport(item)}
                            className="btn btn-link p-0 text-danger border-0"
                            title="Delete File"
                            style={{ lineHeight: 0 }}
                          >
                            <svg width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                              <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                            </svg>
                          </button>
                        </div>

                        <div className="d-flex align-items-center gap-3 w-100 mt-1">
                          <div className={`icon-circle p-2 rounded-circle bg-success-subtle`}>
                            <svg width="20" height="20" fill="currentColor" className="text-success" viewBox="0 0 16 16">
                              <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z" /><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" />
                            </svg>
                          </div>

                          {/* Text Section */}
                          <div className="flex-grow-1 overflow-hidden pe-4">
                            <a
                              className="text-truncate d-block fw-medium text-decoration-none text-primary"
                              style={{ maxWidth: "100%" }}
                              href={item.file_url}
                              target="_blank"
                              rel="noreferrer"
                              title={item.doc_name}
                            >
                              {item.doc_name}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </> : null}
        </div>
      </div>

      <ToastContainer />
    </>
  );
};
export default AdminTemplatesPageAdd;
